import { render, staticRenderFns } from "./distribution-channel-sku.vue?vue&type=template&id=428d3a9d&scoped=true&"
import script from "./distribution-channel-sku.vue?vue&type=script&lang=js&"
export * from "./distribution-channel-sku.vue?vue&type=script&lang=js&"
import style0 from "./distribution-channel-sku.vue?vue&type=style&index=0&id=428d3a9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428d3a9d",
  null
  
)

export default component.exports